import Axios from 'axios'
import Vue from 'vue';
import i18n from '../../i18n';

const state = {
  tagShare: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_TAGSHARE_BUSY: (state, payload) => {
    state.tagShare.isBusy = payload;
  },
  LOAD_TAGSHARE_SUCCESS: (state, payload) => {
    state.tagShare.data = payload;
    state.tagShare.error = null;
  },
  LOAD_TAGSHARE_FAIL: (state, payload) => {
    state.tagShare.error = payload;
    state.tagShare.data = null;
  },
}

const actions = {
  gettagShare: ({ commit, rootState }) => {
    commit('LOAD_TAGSHARE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .get('/tags.json', config)
      .then((response) => {
        commit('LOAD_TAGSHARE_SUCCESS', response.data)
      },)
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_TAGSHARE_FAIL', error)
      })
      .finally(() => commit('LOAD_TAGSHARE_BUSY', false));
  },

  updatetagShare: ({ commit, rootState }, { tagShare }) => {
    commit('LOAD_TAGSHARE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .put('/tags.json', config, tagShare)
      .then((response) => {
        commit('LOAD_TAGSHARE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_TAGSHARE_FAIL', error)
      })
      .finally(() => commit('LOAD_TAGSHARE_BUSY', false));
  },

  createTagShare: ({ commit, state }, value) => {
    commit("LOAD_TAGSHARE_BUSY", true);

    const payload = Object.assign({}, state.tagShare.data, { tags: value });

    commit("LOAD_TAGSHARE_SUCCESS", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};